import Vue from 'vue'
import Router from 'vue-router'
import MyHome from '../components/MyHome'
let ProdDetail = () => import(   /* webpackChunkName:"ProdDetail" */ /* webpackPrefetch:true */'../components/ProdDetail')

Vue.use(Router)


const router = new Router({

  mode: 'history',

  routes: [

    {
      path: '/',
      name: 'MyHome',
      component: MyHome,
      meta: { keepAlive: true }
    },

    {
      path: '/productDetail',
      name: 'ProductDetail',
      component: ProdDetail,
      meta: { keepAlive: false }
    }


  ]

})


export default router